module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/header-large-search/header-large-search.component.scss
// module id = ./src/app/modules/common-module/components/header-large-search/header-large-search.component.scss
// module chunks = 9